import { createFileRoute, redirect } from "@tanstack/react-router";

/** Screening templates. */
export const Route = createFileRoute("/_authenticated/_workforce/hiring/application-templates")({
  beforeLoad: () => {
    throw redirect({ to: "/hiring/screening-templates" });
  },
});
